/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2022-12-15",
    versionChannel: "nightly",
    buildDate: "2022-12-15T00:16:26.229Z",
    commitHash: "cf03ee743079ad4f08706410a1dc465351775108",
};
